import React from "react";

/**
 * Generic handler for text input changes with numeric validation
 * Only allows digits and empty string
 */
export function getNumericInputChangeHandler(
  setValue: (value: number) => void
): (value: string) => void {
  return (value: string) => {
    // Only allow digits and empty string
    if (value === "" || /^\d+$/.test(value)) {
      const numericValue = value === "" ? 0 : Number(value);
      setValue(numericValue);
    }
    // If invalid input, do nothing (keep current value)
  };
}

/**
 * Sets to minimum value when field is empty or zero on blur
 */
export function getNumericInputBlurHandler(params: {
  setValue: (value: number) => void;
  minimumValue: number;
}): (event: React.FocusEvent<HTMLInputElement>) => void {
  return (event: React.FocusEvent<HTMLInputElement>) => {
    const value = event.target.value;
    if (value === "" || Number(value) === 0) {
      // Set to minimum value when field is empty or zero on blur
      params.setValue(params.minimumValue);
    }
  };
}
